import { BaseEntity } from "yt-ng-framework";

export class VazeciProcenatZarade extends BaseEntity{
    constructor(){
        super();
    }

    DatumOd: Date = null;
    ProcenatPlatniPromet: number = 0;
    ProcenatWesternUnion: number = 0;

    Deserialize(input:any){
        this.ID=input.ID;
        this.DatumOd =input.DatumOd ;
        this.ProcenatPlatniPromet=input.ProcenatPlatniPromet;
        this.ProcenatWesternUnion=input.ProcenatWesternUnion;
        return this;
    }

    Serialize(input:VazeciProcenatZarade){
        return input;
    }
}